<template>
  <div>
    <b-row class="mb-4" align-v="center">
      <b-col>
        <b-card>
          <div class="text-center p-4">
            <h4>งบประมาณที่ได้รับจัดสรร</h4>
            <b-card-text>
              <span class="expense mb-3">{{
                (groupFunding.receivedAmount) | numeral("0,0.00")
              }}
                บาท</span>
              <!-- <div class="d-block">
                <table class="table table-borderless table-sm">
                  <tr>
                    <td width="45%">
                      งบประมาณภายใน<br>
                      <strong>{{ internalFundsSum | numeral("0,0.00") }} บาท</strong>
                    </td>
                    <td width="55%">
                      งบประมาณภายนอก<br>
                      <strong>{{ externalFundsSum | numeral("0,0.00") }} บาท</strong>
                    </td>
                  </tr>
                </table>
              </div> -->
            </b-card-text>
          </div>
        </b-card>
      </b-col>
      <b-col>
        <b-card>
          <div class="text-center p-4">
            <h4>งบประมาณที่ใช้ไป</h4>
            <b-card-text>
              <span class="expense mb-3">{{
                (groupFunding.usedAmount) | numeral("0,0.00")
              }}
                บาท</span>
              <!-- <div class="d-block">
                <table class="table table-borderless table-sm">
                  <tr>
                    <td width="45%">
                      งบประมาณภายใน<br>
                      <strong>{{ internalFundsSum | numeral("0,0.00") }} บาท</strong>
                    </td>
                    <td width="55%">
                      งบประมาณภายนอก<br>
                      <strong>{{ externalFundsSum | numeral("0,0.00") }} บาท</strong>
                    </td>
                  </tr>
                </table>
              </div> -->
            </b-card-text>
          </div>
        </b-card>
      </b-col>
      <b-col>
        <b-card>
          <div class="text-center p-4">
            <h4>งบประมาณคงเหลือ</h4>
            <b-card-text>
              <span class="expense mb-3">{{
                (groupFunding.receivedAmount - groupFunding.usedAmount) | numeral("0,0.00")
              }}
                บาท</span>
              <!-- <div class="d-block">
                <table class="table table-borderless table-sm">
                  <tr>
                    <td width="45%">
                      งบประมาณภายใน<br>
                      <strong>{{ internalFundsSum | numeral("0,0.00") }} บาท</strong>
                    </td>
                    <td width="55%">
                      งบประมาณภายนอก<br>
                      <strong>{{ externalFundsSum | numeral("0,0.00") }} บาท</strong>
                    </td>
                  </tr>
                </table>
              </div> -->
            </b-card-text>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <div>
      <table class="table table-striped table-bordered table-sm">
        <thead>
          <tr>
            <th class="text-center align-top" width="40">#</th>
            <th class="text-center align-middle">รายการ</th>
            <th class="text-center align-middle" width="150">ขออนุมัติ</th>
            <th class="text-center align-middle" width="150">ใช้จริง</th>
            <th class="text-center align-middle" width="150">โอนคืน</th>
            <th class="text-center align-middle" width="150">คงเหลือ</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="groupFunding.groupFundingTransactions.length">
            <tr v-for="(item, index) in groupFunding.groupFundingTransactions" :key="index">
              <td class="text-center">{{ index+1 }}</td>
              <td>
                <strong>{{ item.project.name }}</strong><br>
                <small class="text-muted">หน่วยงานเจ้าของโครงการ: {{ item.project.group.name }}</small>
              </td>
              <td class="text-right">{{ item.requestedAmount|numeral("0,0.00") }}</td>
              <td class="text-right">{{ item.usedAmount|numeral("0,0.00") }}</td>
              <td class="text-right">{{ item.returnedAmount|numeral("0,0.00") }}</td>
              <td class="text-right">{{ calculateRemainingFuding(index)|numeral("0,0.00") }}</td>
            </tr>
          </template>
          <tr v-else>
            <td class="text-center py-5" colspan="6">ไม่มีประวัติการใช้งบประมาณ</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    groupFunding: { type: Object, required: true }
  },
  mounted () {
    if (this.groupFunding) {
      console.log(this.groupFunding)
    }
  },
  methods: {
    calculateRemainingFuding (index) {
      if (this.groupFunding.groupFundingTransactions.length !== 0) {
        const useAmountArray = this.groupFunding.groupFundingTransactions.map((item) => item.usedAmount)
        var result = 0
        for (var i = 0; i <= index; i++) {
          var add = result
          result = add + useAmountArray[i]
        }

        return this.groupFunding.receivedAmount - result
      }
    }
  }

}
</script>
